import React, { useState, useEffect } from 'react';
import './AdminDashboardV2.css';
import ProductsPanel from '../components/ProductsPanel';
import FilesPanel from '../components/FilesPanel';
import ProductUpload from '../components/ProductUpload';
import PreordersPanel from '../components/PreordersPanel';
import StatCard from '../components/StatCard';
import StatsPanel from '../components/StatsPanel';
import { useAuth } from "../context/AuthContext";
import VisitorAnalyticsPanel from '../components/VisitorAnalyticsPanel';
import FeaturedProductsManager from '../components/FeaturedProductsManager';
//import ImageManager from '../components/ImageManager';
import ArtImagesManager from '../components/ArtImagesManager';  
import DownloadsManager from '../components/DownloadsManager';
import ArtworkCarousel from '../components/ArtworkCarousel/ArtworkCarousel';

function AdminDashboardV2() {
  const { token, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('stats');

  const tabs = [
    { key: 'stats', label: 'Stats' },
    { key: 'products', label: 'Products' },
    { key: 'files', label: 'Files' },
    { key: 'upload', label: 'Upload Product' },
    { key: 'visitor', label: 'Visitor Analytics' },
    { key: 'preorders', label: 'Preorder Panel' },
    { key: 'featured', label: 'Featured Products' },
    { key: 'art', label: 'Art Images Manager' }, 
    { key: 'downloads', label: 'Downloads' }, 
  ];

  return (
    <div className="admin-dashboard">
      <h1 className="dashboard-title">Admin Dashboard</h1>
      
      <div className="tab-bar">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="tab-content">
        {activeTab === 'stats' && <StatsPanel token={token} setActiveTab={setActiveTab} />}
        {activeTab === 'products' && <ProductsPanel token={token} />}
        {activeTab === 'files' && <FilesPanel token={token} />}
        {activeTab === 'upload' && <ProductUpload token={token} />}
        {activeTab === 'preorders' && <PreordersPanel token={token} />}
        {activeTab === 'visitor' && <VisitorAnalyticsPanel />}
        {activeTab === 'featured' && <FeaturedProductsManager />}
        {activeTab === 'art' && <ArtImagesManager token={token} />}
        //{activeTab === 'art' && <ArtworkCarousel />}
        {activeTab === 'downloads' && <DownloadsManager />}

        <button
          onClick={logout}
          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default AdminDashboardV2;
